import { Injectable, Injector, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';

@Injectable()
export class TrustedApiInterceptor implements HttpInterceptor {
  private injector = inject(Injector);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only add the header to API requests
    if (request.url.startsWith('/api/') || request.url.includes(environment.apiUrl)) {
      request = request.clone({
        setHeaders: {
          'X-Trusted-API': environment.trustedToken
        }
      });
    }

    // Pass the request to the next handler and catch any errors
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0 || error.status === 502 || error.status === 503 || error.status === 504) {
          this.injector.get(AppService).updateState({
            maintenanceMessage: 'Le serveur est indisponible. Veuillez réessayer dans quelques instants.',
          });
          return throwError(() => error);
        }

        // Re-throw the ORIGINAL error to preserve status, headers, etc.
        return throwError(() => error);
      })
    );
  }
}
